import { generateReadActionCreator, generateCreateActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readAddons: generateReadActionCreator(routes.API_PRODUCT_ADDONS, ACTION_NAMES.PRODUCT_ADDONS),
    addAddon: generateCreateActionCreator(routes.API_PRODUCT_ADDONS, ACTION_NAMES.PRODUCT_ADDONS)
}
